import {z as zod, type ZodType} from "zod";
import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {iso8601DateTimeZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

export type OnboardingJourney = {
    id: Uuid;
    createdAt: Iso8601DateTime;
    updatedAt: Iso8601DateTime;
    revisionId: Uuid;
    workspaceId: Uuid;
    // This is not used right now
    status: OnboardingJourneyStatus;
} &
    // TODO: Figure out a good way to automate this kind of thing (possibly using a type map)
    // | {
    //       currentStep: OnboardingJourneyStep.completed;
    //   }
    (| {
              currentStep: OnboardingJourneyStep.connectDataSources;
              currentStepInput: {
                  connectionAttemptIds: Array<Uuid>;
              };
          }
        | {
              currentStep: OnboardingJourneyStep.selectDataSources;
          }
        | {
              currentStep: OnboardingJourneyStep.invalidCatchAll;
          }
    );

export enum OnboardingJourneyStatus {
    "active" = "6d4916a0-1e7a-41b2-80e2-7c57ecade87e",
    "completed" = "9bcb536d-d89b-4060-8aa8-32300d4b3cf9",
    "failed" = "408a33f3-4dc2-4c00-b84f-050a6381cbdb",
}

export enum OnboardingJourneyStep {
    // "completed" = "ebf791f7-f579-443e-88f9-80ca5fa8341a",
    "connectDataSources" = "45e15508-6147-4446-a8a9-616291d43345",
    "selectDataSources" = "9dc6d09d-ef2c-4722-a2f8-975ce67e56f6",
    "invalidCatchAll" = "7d52ba99-7472-42db-8254-189bc2607f27",
}

export const onboardingJourneyZodValidator: ZodType<OnboardingJourney> = zod
    .object({
        id: uuidZodValidator,
        createdAt: iso8601DateTimeZodValidator,
        updatedAt: iso8601DateTimeZodValidator,
        revisionId: uuidZodValidator,
        workspaceId: uuidZodValidator,
        status: zod.enum(OnboardingJourneyStatus),
    })
    .and(
        zod.union([
            // zod.object({
            //     currentStep: zod.literal(OnboardingJourneyStep.completed),
            // }),
            zod.object({
                currentStep: zod.literal(OnboardingJourneyStep.connectDataSources),
                currentStepInput: zod.object({
                    connectionAttemptIds: zod.array(uuidZodValidator),
                }),
            }),
            zod.object({
                currentStep: zod.literal(OnboardingJourneyStep.selectDataSources),
            }),
            zod.object({
                currentStep: zod.literal(OnboardingJourneyStep.invalidCatchAll),
            }),
        ]),
    );
